"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAddressPositionTypeEnum = void 0;
var OrderAddressPositionTypeEnum;
(function (OrderAddressPositionTypeEnum) {
    OrderAddressPositionTypeEnum["Pickup"] = "PICKUP";
    OrderAddressPositionTypeEnum["Dropoff"] = "DROPOFF";
})(OrderAddressPositionTypeEnum || (exports.OrderAddressPositionTypeEnum = OrderAddressPositionTypeEnum = {}));
//# sourceMappingURL=order-address-position-type.enum.js.map